import { EQ_BANDS, EQ_PRESETS } from "@/hooks/useLiveAudio";

// 5-band graphic equalizer; changes apply live to what this listener hears.
export const EqPanel = ({ audio, accent = "var(--t-label)", className = "" }) => {
  const setBand = (i, v) => audio.setEq(audio.eq.map((g, k) => (k === i ? v : g)));
  const preset = Object.entries(EQ_PRESETS).find(([, g]) => g.every((v, i) => v === audio.eq[i]))?.[0] || "CUSTOM";
  return (
    <div className={`eq-panel ${className}`} style={{ "--eq-accent": accent }} data-testid="eq-panel">
      <div className="flex items-center justify-between mb-2 pr-16 font-mono text-[0.6rem] tracking-[0.25em]">
        <span style={{ color: accent }}>EQUALIZER</span>
        <span className="opacity-70" data-testid="eq-preset-name">{preset}</span>
      </div>
      {!audio.eqSupported && <p className="text-[0.65rem] opacity-70 mb-2" data-testid="eq-unsupported">This browser plays the stream natively, so EQ can't change the sound here.</p>}
      <div className="flex justify-between gap-2">
        {EQ_BANDS.map(([, , label], i) => (
          <label key={label} className="flex flex-col items-center gap-1 flex-1 font-mono text-[0.55rem]">
            <span className="opacity-80" data-testid={`eq-band-${i}-value`}>{audio.eq[i] > 0 ? "+" : ""}{audio.eq[i]}</span>
            <input type="range" min={-12} max={12} step={1} value={audio.eq[i]} onChange={(e) => setBand(i, Number(e.target.value))}
              className="eq-slider" aria-label={`${label} Hz`} data-testid={`eq-band-${i}`} />
            <span className="opacity-60">{label}</span>
          </label>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5 mt-3">
        {Object.entries(EQ_PRESETS).map(([name, gains]) => (
          <button key={name} onClick={() => audio.setEq(gains)} className={`eq-chip ${preset === name ? "on" : ""}`}
            data-testid={`eq-preset-${name.toLowerCase().replace(/\s/g, "-")}`}>{name}</button>
        ))}
      </div>
    </div>
  );
};
